export default function SvgPause() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="4rem"
      viewBox="0 -960 960 960"
      width="4rem"
      fill="none"
    >
      <path d="M558.72-240v-480h144.36v480H558.72Zm-301.8 0v-480h144.87v480H256.92Z" />
    </svg>
  );
}
